module.exports = __webpack_public_path__ + "img/13.7b0641ed.png";